<template>
  <div class="page page-track-devices">
    <h3>Устройство</h3>
    <ActionBar
      :isEditing="isEditing"
      @changeAction="changeTrackDevice"
      @saveAction="updateTrackDevice"
      @deleteAction="deleteTrackDevice"
      @cancelAction="cancelTrackDeviceChanges"
    />
    <br />
    <TrackDeviceEditForm v-if="isEditing" class="device-view-edit" :trackDevice="trackDevice" :firmwares="firmwares" />
    <TrackDeviceShowForm v-else class="device-view-edit" :trackDevice="trackDevice" />
  </div>
</template>

<script>
/* eslint-disable camelcase */

import Swal from 'sweetalert2'
import deepAssign from 'assign-deep'
import trackDevicesAPI from '@/api/track-devices'

export default {
  name: 'TrackDevicePage',
  props: ['id'],
  mounted () {
    this.loadData()
    trackDevicesAPI.getFirmwares().then(response => {
      this.firmwares = response
    })
  },
  data () {
    return {
      isUpdating: false,
      prevTrackDevice: null,
      trackDevice: {},
      firmwares: [],
      isEditing: false
    }
  },
  methods: {
    updateTrackDevice () {
      if (this.isUpdating) {
        return
      }
      this.isUpdating = true
      trackDevicesAPI.updateItem(this.trackDevice)
        .then(response => {
          this.trackDevice = response.model
          this.isUpdating = false
          this.isEditing = false
        })
        .catch(text => {
          this.isUpdating = false
          Swal.fire({
            icon: 'error',
            title: 'Ошибка',
            html: text.message
          })
        })
    },
    loadData () {
      trackDevicesAPI.getItem({ id: this.id })
        .then(response => {
          this.trackDevice = response
        })
    },
    changeTrackDevice () {
      this.prevTrackDevice = deepAssign({}, this.trackDevice)
      this.isEditing = true
    },
    cancelTrackDeviceChanges () {
      this.trackDevice = this.prevTrackDevice
      this.isEditing = false
    },
    deleteTrackDevice () {
      trackDevicesAPI.removeItem(this.trackDevice.id)
        .then(() => {
          this.$router.push('/devices')
        })
        .catch(text => {
          Swal.fire({
            icon: 'error',
            title: 'Ошибка',
            html: text.message
          })
        })
    }
  }
}
</script>

<style scoped>
  .page-track-devices {
    width: 98%;
    padding-bottom: 4rem;
    padding-top: 2.5rem;
  }
</style>
